import React from 'react';
import PropTypes from 'prop-types';

import SelectSearch from 'react-select-search';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectBrand } from './actions';
import { FlexSection } from '../UIKit';
import { makeSelectSelectedBrand } from './selectors';
import './brand.scss';

class Brand extends React.Component {
  constructor(props) {
    super(props);
  }

  selectBrand = value => {
    this.props.brandSelected(value);
  };

  renderBrand(props, option, snapshot, className) {
    return (
      <button {...props} className={className} type="button">
        <span>
          <img
            alt="Logo Brand"
            className="CarSelectorBrandLogo"
            width="32"
            height="32"
            src={option.photo}
          />
          <span>{option.name}</span>
        </span>
      </button>
    );
  }

  render() {
    const { title, placeholder, brands, selected } = this.props;
    return (
      <div id="CarSelectorBrand">
        <FlexSection
          title={title}
          children={
            <SelectSearch
              name="car-brand"
              aria-label="Seleziona la marca"
              className="select-search-box select-search-box--multiple"
              value={selected}
              onChange={this.selectBrand}
              options={brands}
              placeholder={placeholder}
              renderOption={this.renderBrand}
              disabled={false}
              search
            />
          }
        />
      </div>
    );
  }
}

Brand.defaultProps = {
  placeholder: 'Seleziona',
  errors: {},
};
Brand.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.string,
  placeholder: PropTypes.string,
  brands: PropTypes.any.isRequired,
  errors: PropTypes.object,
  brandSelected: PropTypes.func.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    brandSelected: brandSlug => dispatch(selectBrand(brandSlug)),
  };
}
const mapStateToProps = createStructuredSelector({
  selected: makeSelectSelectedBrand(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Brand);
